import React from "react";

export const MaterialsTable = ({
  allMaterials,
  materialKeyMap,
  materialDisplayNames,
  design,
  team,
  showSimplified,
}) => {
  return (
    <>
      {/* Table Rows */}
      {Object.entries(allMaterials)
        .filter(
          ([key]) =>
            ![
              "singleGates",
              "doubleGates",
              "gateExtensions",
              "totalLength",
            ].includes(key),
        )
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        .map(([materialKey, quantity]) => {
          // Use the mapping to get the correct design.materials key
          const designMaterialKey = materialKeyMap[materialKey];
          const material = design.materials[designMaterialKey];
          const displayName = materialDisplayNames[materialKey];

          if (!material || !material.included) return null;

          const totalPrice = quantity * material.price;

          if (showSimplified) {
            // Simplified View
            return (
              <div
                key={materialKey}
                className="border-b border-gray-300 p-3 md:grid md:grid-cols-2 md:items-center hover:bg-gray-50"
              >
                {/* Mobile: Simplified */}
                <div className="md:hidden mb-2">
                  <p className="font-bold text-lg">{material.name}</p>
                  <div className="mt-1">
                    <span className="text-gray-500">Qty:</span>
                    <span className="ml-1 font-semibold">{quantity}</span>
                  </div>
                </div>

                {/* Desktop: Simplified */}
                <p className="hidden md:block text-gray-700">{material.name}</p>
                <p className="hidden md:block font-semibold">{quantity}</p>
              </div>
            );
          }

          // Full Details View
          return (
            <div
              key={materialKey}
              className="border-b border-gray-300 p-3 md:grid md:grid-cols-5 md:items-center hover:bg-gray-50"
            >
              {/* Mobile: Stacked layout */}
              <div className="md:hidden mb-2">
                <p className="font-bold text-lg">{displayName}</p>
                <p className="text-gray-600">{material.name}</p>
                <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <span className="text-gray-500">Quantity:</span>
                    <span className="ml-1 font-semibold">{quantity}</span>
                  </div>
                  {team.tierLimits.seePrices && (
                    <div>
                      <span className="text-gray-500">Price:</span>
                      <span className="ml-1 font-semibold">
                        ${material.price}
                      </span>
                    </div>
                  )}
                  <div>
                    <span className="text-gray-500">Total:</span>
                    <span className="ml-1 font-bold text-blue-600">
                      ${totalPrice.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Desktop: Grid layout */}
              <p className="hidden md:block font-medium">{displayName}</p>
              <p className="hidden md:block text-gray-700">{material.name}</p>
              <p className="hidden md:block">{quantity}</p>
              {team.tierLimits.seePrices && (
                <p className="hidden md:block">${material.price}</p>
              )}
              <p className="hidden md:block font-semibold text-blue-600">
                ${totalPrice.toFixed(2)}
              </p>
            </div>
          );
        })}
    </>
  );
};
